import Select from "react-select";
import AceEditor from "react-ace";
import Button from "../../Button";
import constants from "../../../constants";
import { useLocation } from "react-router-dom";
import PlayIconSvg from "../../../Svg/PlayIconSvg";
import React, { useContext, useEffect } from "react";
import ThemeSvgIcon from "../../../Svg/ThemeSvgIcon";
import ResetSvgIcon from "../../../Svg/ResetSvgIcon";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import FullScreenSvgIcon from "../../../Svg/FullScreenSvgIcon";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import CodingEditorHooks from "../../../Hooks/CodingPage/CodingEditorHooks";
import CodingEditorRunButtonHooks from "../../../Hooks/CodingPage/CodingEditorRunButtonHooks";

export default function SQLEditor() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const CodingEditorHks = CodingEditorHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const CodingEditorRunButtonHks = CodingEditorRunButtonHooks();

  const { pathname } = useLocation();

  const handleLearnerCode = (value) => {
    Alert.setTestDetail((prev) => ({ ...prev, solution: value }));

    if (!pathname.includes("library") && !Alert.isAdmin) {
      Alert.setTestDetail((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          sections: prev.data.sections.map((section, index) =>
            index === 0
              ? {
                  ...section,
                  questions: section.questions.map((item) =>
                    item.id === prev.id ? { ...item, solution: value } : item
                  ),
                }
              : section
          ),
        },
      }));
    }
  };

  const handleResetLearnerCode = () => {
    Alert.setTestDetail((prev) => ({
      ...prev,
      solution: prev.hasOwnProperty("boilerPlate") ? prev.boilerPlate : "",
    }));

    if (!pathname.includes("library") && !Alert.isAdmin) {
      Alert.setTestDetail((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          sections: prev.data.sections.map((section, index) =>
            index === 0
              ? {
                  ...section,
                  questions: section.questions.map((item) =>
                    item.id === prev.id ? { ...item, solution: "" } : item
                  ),
                }
              : section
          ),
        },
      }));
    }
  };

  const handleChangeLanguage = (e) => {
    Alert.setTestDetail((prev) => ({ ...prev, selectedLanguage: e }));
  };

  const handleOutput = (picBlob) => {
    let form = new FormData();

    let payload = JSON.stringify({
      qnId: Alert.testDetail.id,
      learnerQuery: Alert.testDetail.solution,
    });

    let url =
      pathname.includes("library") || Alert.isAdmin
        ? "node/admin/library/sql/run"
        : "node/learner/test/sql/run";

    if (pathname.includes("library") || Alert.isAdmin) {
      form.append("solution", Alert.testDetail.solution);
      form.append("dbSchema", Alert.testDetail.dbSchema);
    }
    Alert.setIsLoaded(true);
    axios
      .post(
        url,
        pathname.includes("library") || Alert.isAdmin ? form : payload,
        useCommonFunctionHks.getHeaderDetailsForAxios(
          pathname.includes("library") || Alert.isAdmin ? "multipart" : null
        )
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          // Alert.setTestDetail((prev) => ({
          //   ...prev,
          //   output: Alert.isAdmin ? res.data.data : res.data.data.output,
          // }));
            let isDataObject = false;

            if(Alert.isAdmin){
              isDataObject =typeof res.data.data === "object" &&
              res.data.data !== null &&
              !Array.isArray(res.data.data);
            }
            else {
              isDataObject =
              typeof res.data.data.output === "object" &&
              res.data.data.output !== null &&
              !Array.isArray(res.data.data.output);
            }

          Alert.setTestDetail((prev) => ({
            ...prev,
            output: Alert.isAdmin
              ? isDataObject
                ? [res.data.data]
                : res.data.data
              : isDataObject
              ? [res.data.data.output]
              : res.data.data.output,
          }));
        } else {
          if (typeof res.data.msg !== "object") {
            Alert.setShowNotify({
              show: true,
              title: "Error",
              msg: res.data.msg,
            });
          } else {
            Alert.setTestDetail((prev) => ({
              ...prev,
              error: Object.entries(res.data.msg).map(([key, value]) => ({
                key,
                value,
              })),
            }));
          }

          Alert.setTestDetail((prev) => {
            const { output, ...rest } = prev;

            return rest;
          });
        }
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
  };

  useEffect(() => {
    if (Alert.callAllTestCases.current && Alert.makeRunTestCase) {
      CodingEditorRunButtonHks.handleRunAllTestCase();
      Alert.callAllTestCases.current = false;
      Alert.setMakeRunTestCase(false);
    }
  }, [Alert.makeRunTestCase, Alert.callAllTestCases.current]);

  return (
    <div
      ref={CodingEditorRunButtonHks.editorContainerRef}
      className={
        !Alert.isFullScreen
          ? "codingEditorMainContainer"
          : "codingEditorMainContainerFullScreen"
      }
    >
      <div className="codingEditorHeader">
        <div className="codingEditorLanguage">
          <Select
            isSearchable={false}
            onChange={handleChangeLanguage}
            options={Alert.testDetail.language}
            styles={CodingEditorHks.customStyle}
            value={Alert.testDetail.selectedLanguage}
            isDisabled={CodingEditorHks.handleDisableLanguage()}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </div>
        <div className="codingEditorHeaderRightDiv">
          <ResetSvgIcon onClick={handleResetLearnerCode} />
          <ThemeSvgIcon />
          {!Alert.isAdmin && (
            <FullScreenSvgIcon
              onClick={() =>
                CodingEditorRunButtonHks.handleFullScreenMode(
                  CodingEditorRunButtonHks.editorContainerRef.current
                )
              }
            />
          )}
        </div>
      </div>
      <div>
        <AceEditor
          mode="sql"
          width="100%"
          maxHeight="93vh"
          wrapEnabled={true}
          showPrintMargin={false}
          className="codingEditor"
          theme={Alert.editorTheme}
          highlightActiveLine={true}
          onChange={handleLearnerCode}
          value={Alert.testDetail?.solution}
          editorProps={{ $blockScrolling: false }}
          commands={[
            {
              // commands is array of key bindings.

              name: "pastline", //name for the key binding.
              bindKey: !Alert.isAdmin && { win: "Ctrl-V", mac: "Command-V" }, //key combination used for the command.
              exec: function (editor) {
                const editorEvents = [
                  "drop",
                  "dragend",
                  "dragover",
                  "dragenter",
                  "dragstart",
                  "dragleave",
                ];
                for (const events of editorEvents) {
                  editor.selection.getCursor();
                  editor.container.addEventListener(
                    events,
                    function (e) {
                      e.stopPropagation();
                    },
                    true
                  );
                }
              },
            },
          ]}
          setOptions={{
            tabSize: 4,
            fontSize: 16,
            dragEnabled: false,
            enableSnippets: true,
            showLineNumbers: true,
            wrapBehavioursEnabled: true,
            autoScrollEditorIntoView: true,
            enableLiveAutocompletion: false,
            enableBasicAutocompletion: true,
          }}
        />
        <div className="codingEditorButtonDiv">
          <Button
            size={"sm"}
            onClick={handleOutput}
            icon={{ type: "leading", icon: <PlayIconSvg /> }}
            hierarchy={{
              type: "primary",
              buttonText: "Run Query",
            }}
          />
        </div>
      </div>
    </div>
  );
}
